/* @flow */
import * as React from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';

import type { TranslatorProps } from 'react-i18next';

import type TypeForm from 'forms/_.extend';

import SiteAddress from 'components/SiteAddress/SiteAddress';
import ElectroAssetFamily from 'forms/components/inputs/ElectroAssetFamily/ElectroAssetFamily';
import ActionDrawerFormButtons from 'views/ActionDrawer/components/ActionDrawerFormButtons/ActionDrawerFormButtons';
import ActionDrawerBlock from 'views/ActionDrawer/components/ActionDrawerBlock/ActionDrawerBlock';
import ActionDrawerTable from 'views/ActionDrawer/components/ActionDrawerTable/ActionDrawerTable';
import ActionDrawerLocation from 'views/ActionDrawer/components/ActionDrawerLocation/ActionDrawerLocation';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {|
  asset: Object,
  form: TypeForm,
|} & TranslatorProps;

@translate()
@observer
export default class ChangeAssetLocationForm extends React.Component<*> {
  get siteName() {
    const asset: Object = this.props.asset;
    const names: Array<string> = [asset.location.site.name];

    if (asset.location.building.name) {
      names.unshift(asset.location.building.name);
    }

    if (asset.location.room.name) {
      names.unshift(asset.location.room.name);
    }

    if (asset.location.workspace.name) {
      names.unshift(asset.location.workspace.name);
    }

    return names.join(', ');
  }

  render(): React.Node {
    const { t, asset, form }: TypeProps = this.props;

    const details: Array<*> = [
      [t('general:trading_account'), `${asset.account.name} ${asset.account.number}`],
      [t('general:assets.labels.number'), asset.asset_number],
      [t('general:manufacturer'), asset.manufacturer],
      [t('general:model'), asset.model],
      [t('general:labels.serial_number'), asset.serial_number],
    ];

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <ActionDrawerBlock
            divider={true}
            gutters={true}
            heading={t('general:assets.labels.details')}
          >
            <ActionDrawerTable data={details} />
            <div className={styles['clearfix']} />
            <div className={styles['info-block']}>
              <h3>{t('general:assets.labels.current_location')}</h3>
              {asset.location ? (
                <SiteAddress {...asset.location.site.address} siteName={this.siteName} />
              ) : (
                <ul>
                  <li>{t('general:search_results.no_location_found')}</li>
                </ul>
              )}
            </div>
          </ActionDrawerBlock>
          {asset.owned && (
            <ElectroAssetFamily
              field={form.$('moveAssets.assetsToMove')}
              assetId={asset.id}
              heading={t('general:actions.select_assets_to_move')}
            />
          )}
          <ActionDrawerBlock gutters={true} heading={form.$('changeLocation').label}>
            <ActionDrawerLocation
              field={form.$('changeLocation.location')}
              accountId={asset.account.id}
            />
          </ActionDrawerBlock>
        </div>
        <ActionDrawerFormButtons form={form} submitTxt={t('general:actions.change_location')} />
      </React.Fragment>
    );
  }
}
